import {useAccountOverviewRoute} from '@aboutyou/router';
import {ErrorPageInline} from '@aboutyou/ui-components';
import React from 'react';

export const OSPErrorView = () => {
  const accountOverview = useAccountOverviewRoute();

  return <ErrorPageInline url={accountOverview} />;
};
